<script>
/**
 * Descripción: componente menú lateral
 *
 * @displayName BaseDrawer
 */

export default {
  name: 'BaseDrawer',

  props: {
    status: {
      requiered: true
    },

    right: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<template>
  <v-navigation-drawer
    :stateless="true"
    :value="status"
    :clipped="right ? false : $vuetify.breakpoint.smAndUp"
    :right="right"
    app
  >
    <!-- @slot Agregar Contenido -->
    <slot name="container"></slot>

    <!-- @ Use Logo MDG -->
    <template v-slot:append>
      <div
        class="pa-2"
        style=" display: flex;
        align-items: center;
        justify-content: center;"
      >
        <img v-if="!right" src="@/assets/SaasManagerLogo.svg" height="80px" />
      </div>
    </template>
  </v-navigation-drawer>
</template>
